/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
import React, { useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import * as S from './Loader.styles';

export interface ILoaderProps {
  useModalLoader?: boolean;
  useCustomLoadingText?: boolean;
  customLoadingText?: string;
  titleNormalText?: string;
  titleBoldText?: string;
  description?: string;
  loadingKeyWords?: string[];
}

export const Loader = ({
  useModalLoader,
  useCustomLoadingText,
  customLoadingText,
  titleNormalText,
  description,
  titleBoldText,
  loadingKeyWords,
}: ILoaderProps) => {
  const [visible, setVisible] = useState(true);

  const _renderWords = (modalLoader: boolean) => {
    return (
      <S.AnimatedTextContainer useModalLoader={modalLoader}>
        <S.AnimatedText
          data-text={`${titleNormalText} ${titleBoldText || ''}`}
        />
      </S.AnimatedTextContainer>
    );

    // return (
    //   <S.Loader useModalLoader={modalLoader}>
    //     <S.LoadingText>
    //       {titleNormalText} <b>{titleBoldText}</b>

    //       {/* {description} */}
    //     </S.LoadingText>
    //     <S.Words>
    //       {loadingKeyWords?.map((item, index) => {
    //         return <S.Word key={index}>{item?.toLocaleLowerCase()}</S.Word>;
    //       })}
    //     </S.Words>
    //   </S.Loader>
    // );
  };

  if (useModalLoader) {
    return (
      <Modal
        show={visible}
        onHide={() => setVisible(false)}
        backdrop={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <S.ModalInnerContainer>
          <S.Spinner useModalLoader={true} />
          {_renderWords(true)}
        </S.ModalInnerContainer>
      </Modal>
    );
  }

  return (
    <Container className="justify-content-center">
      <Row>
        <Col
          xs={12}
          className="text-center d-flex align-items-center justify-content-center"
        >
          <div style={{ height: '60vh' }}>
            <S.LoaderContainer>
              <S.Spinner useModalLoader={false} />
              {_renderWords(false)}
            </S.LoaderContainer>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

Loader.defaultProps = {
  useModalLoader: false,
  useCustomLoadingText: false,
  customLoadingText: 'Request in Progress',
  titleNormalText: 'loading',
  // loadingKeyWords: ["tickets"],
};

export default Loader;
